<template>
  <div class="main-layout__list main-layout__list_mxh91">
    <div
      class="main-layout__item main-layout__item_head main-layout__item_hover main-layout__item_p14"
    >
      <div class="w-3 t-c foz-23">
        <span>#</span>
      </div>
      <div class="w-10">
        <span>{{ $t("listsHeader.createdAt") }}</span>
      </div>
      <div class="w-10">
        <span>PDF-Typ</span>
      </div>
      <div class="w-10">
        <span>{{ $t("listsHeader.full_name") }}</span>
      </div>
      <div class="w-10">
        <span>{{ $t("forms.phone") }}</span>
      </div>
      <div class="w-10">
        <span>E-mail</span>
      </div>
      <div class="w-10">
        <span>{{ $t("listsHeader.price") }}</span>
      </div>
      <div class="w-10">
        <span>{{ $t("listsHeader.actions") }}</span>
      </div>
    </div>

    <div
      class="main-layout__item main-layout__item_hover main-layout__item_mh"
      v-for="(item, index) in list"
      :key="item.id"
    >
      <div class="w-3 t-c">
        <span>{{ index + 1 }}</span>
      </div>
      <div class="w-10">
        <span>{{ convertDate(item.created_at) }}</span>
      </div>
      <div class="w-10">
        <span>{{ convertType(item.type) }}</span>
      </div>
      <div class="w-10">
        <span>{{ item.client.client_name }}</span>
      </div>
      <div class="w-10">
        <span>{{ item.client.client_phone }}</span>
      </div>
      <div class="w-10">
        <span>{{ item.client.client_email }}</span>
      </div>
      <div class="w-10">
        <span>€ {{ getPrice(item.total) }}</span>
      </div>
      <div class="main-layout__item-actions w-10">
        <div>
          <svg @click="openEditModal(item)" class="main-layout__item-icon">
            <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
          </svg>
        </div>
        <a class="orders-item__pdf" :href="item.file_path" target="_blank">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 482.14 482.14"
            xml:space="preserve"
            class="main-layout__item-icon"
          >
            <g>
              <g>
                <path
                  d="M142.024,310.194c0-8.007-5.556-12.782-15.359-12.782c-4.003,0-6.714,0.395-8.132,0.773v25.69   c1.679,0.378,3.743,0.504,6.588,0.504C135.57,324.379,142.024,319.1,142.024,310.194z"
                  data-original="#000000"
                  class="active-path"
                  data-old_color="#000000"
                  fill="#9bcd82"
                />
                <path
                  d="M202.709,297.681c-4.39,0-7.227,0.379-8.905,0.772v56.896c1.679,0.394,4.39,0.394,6.841,0.394   c17.809,0.126,29.424-9.677,29.424-30.449C230.195,307.231,219.611,297.681,202.709,297.681z"
                  data-original="#000000"
                  class="active-path"
                  data-old_color="#000000"
                  fill="#9bcd82"
                />
                <path
                  d="M315.458,0H121.811c-28.29,0-51.315,23.041-51.315,51.315v189.754h-5.012c-11.418,0-20.678,9.251-20.678,20.679v125.404   c0,11.427,9.259,20.677,20.678,20.677h5.012v22.995c0,28.305,23.025,51.315,51.315,51.315h264.223   c28.272,0,51.3-23.011,51.3-51.315V121.449L315.458,0z M99.053,284.379c6.06-1.024,14.578-1.796,26.579-1.796   c12.128,0,20.772,2.315,26.58,6.965c5.548,4.382,9.292,11.615,9.292,20.127c0,8.51-2.837,15.745-7.999,20.646   c-6.714,6.32-16.643,9.157-28.258,9.157c-2.585,0-4.902-0.128-6.714-0.379v31.096H99.053V284.379z M386.034,450.713H121.811   c-10.954,0-19.874-8.92-19.874-19.889v-22.995h246.31c11.42,0,20.679-9.25,20.679-20.677V261.748   c0-11.428-9.259-20.679-20.679-20.679h-246.31V51.315c0-10.938,8.921-19.858,19.874-19.858l181.89-0.19v67.233   c0,19.638,15.934,35.587,35.587,35.587l65.862-0.189l0.741,296.925C405.891,441.793,396.987,450.713,386.034,450.713z    M174.065,369.801v-85.422c7.225-1.15,16.642-1.796,26.58-1.796c16.516,0,27.226,2.963,35.618,9.282   c9.031,6.714,14.704,17.416,14.704,32.781c0,16.643-6.06,28.133-14.453,35.224c-9.157,7.612-23.096,11.222-40.125,11.222   C186.191,371.092,178.966,370.446,174.065,369.801z M314.892,319.226v15.996h-31.23v34.973h-19.74v-86.966h53.16v16.122h-33.42   v19.875H314.892z"
                  data-original="#000000"
                  class="active-path"
                  data-old_color="#9bcd82"
                  fill="#9bcd82"
                />
              </g>
            </g>
          </svg>
        </a>

        <div
          v-if="item.type !== 'act-acceptance'"
          @click="openRequestModal(item)"
        >
          <svg class="main-layout__item-icon">
            <use xlink:href="/images/svg/symbols.svg#svg-add-work" />
          </svg>
        </div>

        <div v-if="$guard('write', 'PDF')">
          <svg
            @click="openDeleteModal(item.id)"
            width="24px"
            height="24px"
            class="main-layout__item-icon"
          >
            <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
          </svg>
        </div>
      </div>
    </div>

    <modal
      :show="isShowDeleteModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeDeleteModal"
    >
      <delete-modal
        :title="$t('global.areUsure')"
        @cancel="closeDeleteModal"
        @next="deleteConfirm"
      />
    </modal>

    <modal
      :show="showModalAdd"
      :dark="true"
      :outside="false"
      @close="toggleShowRequestModalAdd"
    >
      <transition name="showmodal">
        <request-add-modal @close="toggleShowRequestModalAdd" />
      </transition>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import requestAddModal from '@/components/modals/requests/requestAddModal'
import date from '@/mixins/date'
import rounded from '@/utils/rounded'
import formatPrice from '@/utils/formatPrice'
import moment from 'moment'

export default {
    name: 'pdfList',
    mixins: [date],
    components: {
        requestAddModal,
    },
    computed: {
        ...mapGetters({
            list: 'pdf/list',
            showModalAdd: 'requests/showModalAdd',
        }),
        isHilfy() {
            return this.$config.behavior === 'hilfy'
        },
    },
    data() {
        return {
            isShowDeleteModal: false,
            deletedId: null,
        }
    },
    methods: {
        ...mapMutations({
            setState: 'pdf/setState',
            toggleShowRequestModalAdd: 'requests/toggleShowModalAdd',
            setContact: 'requests/setContact',
            setFormData: 'requests/setFormData',
        }),
        getPrice(price) {
            return formatPrice(rounded(price))
        },
        convertType(type) {
            return type === 'act-acceptance' ? 'Arbeitsschein' : 'Angebot'
        },
        openDeleteModal(id) {
            this.deletedId = id
            this.isShowDeleteModal = true
        },
        closeDeleteModal() {
            this.isShowDeleteModal = false
        },
        openEditModal(item) {
            const isActive = item.type === 'commercial-offer' ? 'angebot' : 'arbeitsschein'
            this.setState({ key: 'isActive', data: isActive })

            this.setState({
                key: 'pdf',
                data: {
                    ...item.data,
                    total: item.data.totalNoVat,
                },
            })
            this.setState({ key: 'isShowModal', data: true })
        },
        async deleteConfirm() {
            const response = await this.remove(this.deletedId)
            const isOkey = response.status === 204

            if (!isOkey) return

            this.fetch()
            this.closeDeleteModal()
        },
        ...mapActions({
            remove: 'pdf/remove',
            fetch: 'pdf/fetch',
        }),
        getDate(v) {
            const localDate = v === null ? moment().add(1, 'd') : moment(v, 'DD/MM/YYYY')
            return moment(moment(localDate).format('YYYY-MM-DDT22:00:00.000[Z]'))
                .set({
                    hour: 8, minute: 0, second: 0, millisecond: 0,
                })
                .subtract(1, 'd')
                .toISOString()
        },
        // openRequestModal(id, day) {
        //   this.setFormData({ key: "service_id", value: id });
        // this.setFormData({
        //   key: "dateOptions",
        //   value: { text: this.getDate(moment(day)), value: null },
        // });
        //   this.toggleShowModalAdd();
        // },
        setRequestFormData(item) {
            this.setFormData({ key: 'isAngebot', value: true })
            this.setFormData({ key: 'total', value: parseFloat(item.total) })
            this.setFormData({ key: 'office_id', value: item.data.office_id })
            this.setFormData({ key: 'service_id', value: item.data.service_id })
            this.setFormData({ key: 'duration', value: item.data.price.time })
            this.setFormData({ key: 'description', value: '' })
            this.setFormData({ key: 'images', value: [] })
            this.setFormData({
                key: 'dateOptions',
                value: {
                    text: this.getDate(moment(item.data.should_started_at)),
                    value: null,
                },
            })
            this.setFormData({
                key: 'executors',
                value: item.data.executors,
            })

            const { address } = item.data
            if (address) {
                this.setFormData({
                    key: 'address',
                    value: {
                        house: address.house,
                        street: address.street,
                        postcode: address.postcode,
                        city: address.city,
                        country: address.country,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        apartment: address.apartment,
                    },
                })
            }
            //   const address = client.addresses[0];

            // }
        },
        openRequestModal(item) {
            this.setContact(item.data.contact)
            this.setRequestFormData(item)
            this.toggleShowRequestModalAdd()
        },
    // ...mapMutations({
    //   setState: "offices/setState",
    // }),
    // ...mapActions({
    //   remove: "offices/remove",
    //   fetch: "offices/fetch",
    // }),
    // openDeleteModal(id) {
    //   this.deletedId = id;
    //   this.isShowDeleteModal = true;
    // },
    // closeDeleteModal() {
    //   this.isShowDeleteModal = false;
    // },
    // openEditOfficeModal(office) {
    //   this.setState({
    //     key: "office",
    //     data: { ...office },
    //   });
    //   this.setState({
    //     key: "isShowModal",
    //     data: true,
    //   });
    // },
    // async deleteConfirm(id) {
    //   const isOkey = await this.remove(this.deletedId);
    //   if (!isOkey) return;
    //   this.fetch();
    //   this.closeDeleteModal();
    // },
    },
}
</script>
